export default{
    tarifas: [],
    tarifaSelec: null,
}